/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staple_At_HomeInputs */

const en_staple_at_home = /** @type {(inputs: Staple_At_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At home`)
};

const de_staple_at_home = /** @type {(inputs: Staple_At_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu Hause`)
};

/**
* | output |
* | --- |
* | "At home" |
*
* @param {Staple_At_HomeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const staple_at_home = /** @type {((inputs?: Staple_At_HomeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staple_At_HomeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_staple_at_home(inputs)
	return en_staple_at_home(inputs)
});